import React, { Component } from 'react'
import Tabs from 'react-bootstrap/Tabs'
import Tab from 'react-bootstrap/Tab'
import Container from 'react-bootstrap/Container'
import Button from 'react-bootstrap/Button'
import {getLocal, setLocal} from '../services/storage'
import Row from 'react-bootstrap/Row'
import { NewLanguageEditor } from './newLanguageEditor'
import { useNavigate } from 'react-router-dom'
import { isBeta } from '../services/network';
import { PasswordChanger } from './revised_components/passwordChanger'

export function UtilitiesPage(props) {
  const navigate = useNavigate();
  return <UtilitiesPageClass {...props} navigate={navigate} />;
}

export class UtilitiesPageClass extends Component {

  constructor(props){
    super(props)
    props.setTitle('Admin Area')
    this.state = {
      inspList: null,
      repList: null,
      betaAccess: 'Enable beta access',
      clientRef: React.createRef(),
      onClicked: this.onClicked.bind(this),
      beta: this.beta.bind(this),
      startTimer: this.startTimer.bind(this),
      endTimer: this.endTimer.bind(this),
      timeFunction: this.timeFunction.bind(this),
    }
  }

  async timeFunction(callback){
    return new Promise(async resolve=>{
      this.state.startTimer(true)
      let res = await callback()
      this.state.endTimer()
      console.log('function executed in', this.time/1000, 'seconds')
      return resolve(res)
    })
  }

  startTimer(log=false){
    this.time = 0
    let timeId = setInterval(()=>{
      if(log && this.time%1000 === 0) console.log('timing function...', `${this.time/1000}s`)
      this.time += 100
    }, 100)

    this.setState({timeId})
    // return time
  }
  endTimer(){
    let {timeId} = this.state
    clearInterval(timeId)
  }


  onClicked(type, info){
    this.props.navigate(`/${type}/${info.original._id}`)
  }

  handleChange(evt){
    this.setState({[evt.target.id]: evt.target.value})
  }

  

  async beta(){
    const betaAccessStatus = await isBeta();
    if (betaAccessStatus && betaAccessStatus === 'true' ){
      await setLocal('betaAccess', "false")
      // await setLocal('locOpHistId', {})
      await setLocal('photoQueue', {})
      await setLocal('markCountRep', {})
      await setLocal('markCountInsp', {})
      try{
        // await db.delete()
      }catch( e ){}
      this.setState({betaAccess: 'Enable beta access'})
      window.location.reload()

    } else {
      await setLocal('betaAccess', "true")
      // await setLocal('locOpHistId', {})
      await setLocal('photoQueue', {})
      await setLocal('markCountRep', {})
      await setLocal('markCountInsp', {})
      try{
        // await db.delete()
      }catch( e ){}

      this.setState({betaAccess: 'Disable beta access'})
      window.location.reload()

    }
  }


  async componentDidMount(){
    // const user = await getLocal('user')
    const betaAccessStatus = await isBeta();
    if (betaAccessStatus && betaAccessStatus === 'true' ){
      this.setState({betaAccess: 'Disable beta access'})
    }
    //this.props.setMenuOptions([])
    this.props.setTitle(`Utilities`)

  }

 

  render() {
    // const {inspList, repList, onClicked} = this.state

    /// FIX PEPPERWOOD

    

    /// END FIX PEPPERWOOD
    const openDev = () => {
      
    }

    // console.log('looking at user', this.props.user)
    return (
      <Container fluid className="large-content scrollable">
        <Tabs>
          <Tab eventKey="password" title="Change Password">
            <PasswordChanger />
          </Tab>
          <Tab eventKey='tools' title='Tools'>
            <Row>
              <Button onClick={openDev} key="save" variant="info">
                Open dev tools
              </Button>

            </Row>

          </Tab>
          <Tab eventKey="langEdit" title="Language Editor">
            <NewLanguageEditor />
          </Tab>
        </Tabs>
        
            
            
          
      </Container>
    )
  }
}
